import { render } from "./CardPointeCompare.vue?vue&type=template&id=5b36a41a&scoped=true"
import script from "./CardPointeCompare.vue?vue&type=script&lang=js"
export * from "./CardPointeCompare.vue?vue&type=script&lang=js"

import "./CardPointeCompare.vue?vue&type=style&index=0&id=5b36a41a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b36a41a"]])

export default __exports__